import { render, staticRenderFns } from "./login-callback.html?vue&type=template&id=4028d9a3&scoped=true&"
import script from "./login-callback.js?vue&type=script&lang=js&"
export * from "./login-callback.js?vue&type=script&lang=js&"
import style0 from "./login-callback.scss?vue&type=style&index=0&id=4028d9a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4028d9a3",
  null
  
)

export default component.exports